module.exports = "<ul class=\"nav nav-tabs\">\n    <li role=\"presentation\" ui-sref-active=\"active\" ng-class=\"{'disabled': object === null}\">\n        <a ui-sref=\".hit_percentage\" ng-bind=\"'Hit percentage'\"></a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\">\n    <div ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/hit_percentages/templates/detail.section.html
// module id = 821
// module chunks = 0